import type { Entry } from 'contentful';

import { TypeNavItemSkeleton } from '../models/cms';
import { NavItemData } from '../models';

export const transformNavItem = (entry: Entry<TypeNavItemSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>): NavItemData => ({
  leftIcon: entry.fields.icon,
  rightIcon: entry.fields.rightIcon,
  label: entry.fields.label,
  url: entry.fields.url,
});
